module.exports = __webpack_public_path__ + "static/media/icon-plus.13cfaac7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-plus.svg
// module id = 113
// module chunks = 0